
// import { createSlice } from "@reduxjs/toolkit";

// const upgradePlanModalSlice = createSlice({
//   name: "upgradePlanModal",
//   initialState: {
//     upgradePlanOpen: false,
//     logoutOpen: false,
//   },
//   reducers: {
//     openUpgradeModal: (state) => {
//       state.upgradePlanOpen = true;
//     },
//     closeUpgradeModal: (state) => {
//       state.upgradePlanOpen = false;
//     },
//   },
// });

// export const { openUpgradeModal, closeUpgradeModal } = upgradePlanModalSlice.actions;
// export default upgradePlanModalSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const upgradePlanModalSlice = createSlice({
  name: "upgradePlanModal",
  initialState: {
    upgradePlanOpen: false,
    errorMessage: "", // store error here
  },
  reducers: {
    openUpgradeModal: (state, action) => {
      state.upgradePlanOpen = true;
      state.errorMessage = action.payload || ""; // set error message
    },
    closeUpgradeModal: (state) => {
      state.upgradePlanOpen = false;
      state.errorMessage = ""; // reset error message
    },
  },
});

export const { openUpgradeModal, closeUpgradeModal } = upgradePlanModalSlice.actions;
export default upgradePlanModalSlice.reducer;
